import React, {ChangeEvent, useEffect, useState} from 'react';
import axios from 'axios';

import './ServiceRating.css'
import {PublicApiConsignmentResponse} from "../Representation";
import {ReactStars} from "new-react-stars";
import {IconExclamationTriangle, IconSpin} from "./Icons";

const MAX_COMMENT_CHARS = 1000;

interface ServiceRatingProps {
    apiOrigin: string
    trackingToken: string
    consignment: PublicApiConsignmentResponse
}

const ServiceRating = (
    props: ServiceRatingProps
) => {

    const [stateSubmitting, setStateSubmitting] = useState(false)
    const [stateSubmitErrorMessage, setStateSubmitErrorMessage] = useState<string | null>(null)
    const [stateRating, setStateRating] = useState(0)
    const [stateComments, setStateComments] = useState<string | null>(null)
    const [stateServiceRatingProvided, setStateServiceRatingProvided] = useState(false)

    useEffect(() => {
        if (props.consignment && props.consignment.serviceRatingProvided) {
            setStateServiceRatingProvided(true)
        }
    }, [props.consignment]);

    const submitRating = () => {
        if (stateRating < 1) {
            setStateSubmitting(false)
            setStateSubmitErrorMessage("Please select at least 1 star")
            return;
        }
        if ((stateComments?.length ?? 0) > MAX_COMMENT_CHARS) {
            setStateSubmitting(false)
            setStateSubmitErrorMessage("Please limit your comments to 1,000 characters")
            return;
        }

        setStateSubmitting(true)
        setStateSubmitErrorMessage(null)

        axios.post(`/tracking/${props.trackingToken}/service-ratings`, {
            "qualityRating": stateRating,
            "comments": stateComments
        }).then((/*response*/) => {
            setStateServiceRatingProvided(true)
        }).catch((/*error*/) => {
            setStateSubmitErrorMessage("Thank you for providing your feedback however an error has occurred submitting it.  Please check your network connection and try again.");
        }).finally(() =>  {
            setStateSubmitting(false)
        });
    };

    const onRatingChanged = (rating: number) => {
        setStateRating(rating);
    };

    const onCommentsChanged = (event: ChangeEvent<any>) => {
        setStateComments(event.target.value);
        setStateSubmitErrorMessage(null)
    };

    const charCount = stateComments?.length ?? 0;

    return (
        <div className="service-rating row end-xs">
            {stateServiceRatingProvided &&
                <div className="col-xs-12 start-xs">
                    <h4>Thank You</h4>
                    <p>Your feedback is highly appreciated and will help us to improve our ability to serve you and other customers.</p>
                </div>
            }

            {!stateServiceRatingProvided &&
            <>
                <div className="col-xs-12 col-md-4">
                    <ReactStars
                        count={5}
                        onChange={onRatingChanged}
                        size={48}
                        value={stateRating}
                        half={false}
                        color1={'#bfbfbf'}
                        color2={'#e93530'}
                        char="☆"
                    />
                </div>
                <div className="col-xs-12 col-md">
                    <textarea
                        placeholder="Your feedback"
                        disabled={stateSubmitting}
                        value={stateComments ?? undefined}
                        onChange={onCommentsChanged}
                    ></textarea>
                    <small>{charCount} / {MAX_COMMENT_CHARS} characters</small>
                    {stateSubmitErrorMessage &&
                        <div className="error">
                            <p><IconExclamationTriangle /> {stateSubmitErrorMessage}</p>
                        </div>
                    }
                    <p><button className="btn btn-submit" type="button" onClick={submitRating}>
                        {stateSubmitting ? <IconSpin spin={true} /> : "SUBMIT"}
                    </button></p>
                </div>
            </>
            }
        </div>
    )

}

export default ServiceRating;
